import { color, snap, typeStyle, units } from '@m/alchemy-ui/theme';

import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: ${units(2)};
  }
`;

export const ChallengeImageWrapper = styled.div`
  height: ${snap(200)};
  width: 100%;
  margin-top: ${units(1.5)};
`;

export const ChallengeHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const ChallengeTitle = styled.a`
  font: ${typeStyle('headerM')};
  font-weight: 400;
`;

export const ChallengeTitleGreyout = styled.a`
  font: ${typeStyle('headerM')};
  font-weight: 400;
  color: #757575;
  pointer-events: none;
  text-decoration: underline;
`;

export const ChallengeDescription = styled.div`
  margin: 8px 0px 8px 0px;
  line-height: 1.3;

  .shortDescription {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    position: absolute;
    right: 28px;
    display: inline-block;
    color: ${color('base', { palette: 'interactiveConstructive' })};
    font-size: 13px;
    cursor: pointer;
    padding: 0;
  }
`;
